// extracted by mini-css-extract-plugin
export var csatScore = "_lw-5";
export var header = "_lw-1";
export var panelWrapper = "_lw-2";
export var postPreview = "_lw-3";
export var rightContent = "_lw-0";
export var wrappingText = "_lw-4";